import { render, staticRenderFns } from "./ProductListView.vue?vue&type=template&id=632d5be8&scoped=true&"
import script from "./ProductListView.vue?vue&type=script&lang=js&"
export * from "./ProductListView.vue?vue&type=script&lang=js&"
import style0 from "./ProductListView.vue?vue&type=style&index=0&id=632d5be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632d5be8",
  null
  
)

export default component.exports